import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/capital-amount?${params}`);
  },
  getById(id) {
    return api.get(`/api/v1/capital-amount/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/capital-amount`, data);
  },
  update(id, data) {
    return api.put(`/api/v1/capital-amount/${id}`, data);
  },
  getAllTransfers(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/capital-amount-transfer?${params}`);
  },
  createTransfer(data) {
    return api.post(`/api/v1/capital-amount-transfer`, data);
  },
};
